module.exports = __webpack_public_path__ + "static/media/meat-and-fruit-large.1da76023.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2020-06-06/meat-and-fruit-large.jpg
// module id = 829
// module chunks = 0